import {
  ImportAccountingDoctolibCsvDazzApiPayload,
  ImportAccountingDoctolibCsvDazzApiResponse,
} from '@omecare/utils';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import envService from '@/utils/env.service';
import http from '@/utils/http.service';

const sampleManualReviewItems: Extract<
  ImportAccountingDoctolibCsvDazzApiResponse,
  { status: 'needs_manual_review' }
>['items'] = [
  {
    invoiceIdentifier: 'F-2026-0001',
    beneficiary: 'Jean Dupont',
    date: '2026-04-15',
    totalAmountDue: 120,
    totalAmountPaid: 120,
    slotsThatDay: [
      {
        id: 'slot-mock-1',
        periodOfTheDay: 'morning',
        startAt: '2026-04-15T08:00:00.000Z',
        endAt: '2026-04-15T12:00:00.000Z',
        doctorSubstituteId: null,
      },
    ],
    attendingHasWorkScheduleThatDay: true,
  },
  {
    invoiceIdentifier: 'F-2026-0002',
    beneficiary: 'Marie Martin',
    date: '2026-04-16',
    totalAmountDue: 80,
    totalAmountPaid: 80,
    slotsThatDay: [],
    attendingHasWorkScheduleThatDay: true,
  },
  {
    invoiceIdentifier: 'F-2026-0003',
    beneficiary: 'Paul Bernard',
    date: '2026-04-17',
    totalAmountDue: 60,
    totalAmountPaid: 60,
    slotsThatDay: [],
    attendingHasWorkScheduleThatDay: false,
  },
];

const importDoctolibCsvDazz = async (
  payload: ImportAccountingDoctolibCsvDazzApiPayload,
): Promise<ImportAccountingDoctolibCsvDazzApiResponse> => {
  if (envService.env.feature.dazzImportMock) {
    await new Promise((resolve) => setTimeout(resolve, 300));
    if (payload.manualResolutions) {
      return { status: 'success' };
    }
    return { status: 'needs_manual_review', items: sampleManualReviewItems };
  }
  return http.accountings
    .importDoctolibCsvDazz(payload)
    .then(({ response }) => response);
};

const useAccountingImportDoctolibCsvDazzMutation = (): UseMutationResult<
  ImportAccountingDoctolibCsvDazzApiResponse,
  Error,
  ImportAccountingDoctolibCsvDazzApiPayload
> => {
  return useMutation({
    mutationFn: importDoctolibCsvDazz,
  });
};

export default useAccountingImportDoctolibCsvDazzMutation;
